var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',_vm._b({staticClass:"cancel-publish-request",attrs:{"icon":"el-icon-delete","type":"danger","size":"small","plain":"","loading":_vm.loading},on:{"click":_vm.cancelPublishRequestAfterConfirm}},'ElButton',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.$t('APP.ACTIONS.CANCEL_PUBLISH_REQUEST_TITLE'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }